import React from "react";

import { addUtmParamsToSectionNavigators } from "../../../Common/utils/NavigationUtils";
import { useValidateQueryParams } from "../../../Common/utils/hooks/QueryParams/useValidateQueryParams";

import Image from "../Image";

import "./Navbar.css";

export default function Navbar() {
  const verifiedUtm = useValidateQueryParams();
  return (
    <section>
      <header className="div_block">
        <Image
          src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/nxtwave-intensive.png"
          alt="INTENSIVE"
          width={203}
          height={53}
          className="logo"
        />
        <nav role="navigation" className="nav_items">
          <a
            referrerPolicy="no-referrer-when-downgrade"
            id="testimonials-navbar"
            href={addUtmParamsToSectionNavigators(verifiedUtm, "#testimonials")}
          >
            Testimonials
          </a>
          <a
            referrerPolicy="no-referrer-when-downgrade"
            id="nxtwave-vs-others-navbar"
            href={addUtmParamsToSectionNavigators(
              verifiedUtm,
              "#nxtwave-vs-others"
            )}
          >
            NxtWave Vs Others
          </a>
        </nav>
      </header>
    </section>
  );
}
